import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock, setAlert} from 'Skelet/src/modules/fetch.action.js'
import refresh_icon from './28406.svg';


class AutoGetChannel extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      auto_running: false,
      auto_max: null,
      auto_count: null,
      auto_retrieved: null,
      auto_estimate: null
    };
  }

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "ttv_list", "GET", config.api_url+"/ttv-list?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "ttv_list", "GET", config.api_url+"/ttv-list?t="+nextProps.session_token);
    }
  }

  render() {
    let cards = null, page_cards = this.props.apiData["ttv_list"];

    let data_has_ids = page_cards !== undefined && page_cards.data !== undefined && page_cards.data !== null && page_cards.data[0] !== undefined;
    if(data_has_ids) {
      cards = <div className="card settings">
        <div>{page_cards.data.length} id's opgehaald.</div>
        <div>count: {this.state.auto_count} / {page_cards.data.length}</div>
        <div style={{fontWeight:"bold"}}>retrieved / max: {this.state.auto_retrieved} / {this.state.auto_max}</div>
        <div>estimate: {this.state.auto_estimate}</div>
        <div style={{textAlign:"center"}}><button onClick={() => this.autoGetChannelStart()} className="btn" disabled={this.state.auto_running}>autom8</button></div>
        <div style={{textAlign:"center"}}><button onClick={() => this.autoGetChannelStop()} className="btn" disabled={!this.state.auto_running}>stop</button></div>
      </div>;
    } else {
      cards = <div className="card settings">
        <div>geen id's opgehaald.</div>
      </div>;
    }

    return (
      <div className="container content" ref={this.setWrapperRef}>
        <div className="refresher"><img src={refresh_icon} alt="Vernieuwen" onClick={() => this.refresh()}/></div>
        {cards}
      </div>
    );
  }

  refresh() {
    this.props.clearStateBlock("ttv_list");
  }

  autoGetChannelStart() {
    let page_cards = this.props.apiData["ttv_list"];
    let auto_max = page_cards.data.length;
    let auto_estimate = ""+(auto_max*.27)+"-"+(auto_max*.31)+" seconds";
    let auto_count = 0, auto_retrieved = 0;
    this.setState({auto_running:true, auto_max, auto_estimate, auto_count, auto_retrieved});
    this.props.clearStateBlock("ttv_channel_info");
    document.title = "RETRIEVING";

    this.autoGetChannelRun(true);
  }

  autoGetChannelStop() {
    this.setState({auto_running:false});
  }

  autoGetChannelRun(first = false) {
    if(this.props.apiData["ttv_channel_info"] === undefined || this.props.apiData["ttv_channel_info"].isFetching === false) {
      let timeout_ms = Math.floor(Math.random()*40) + 270;
      if(this.props.apiData["ttv_channel_info"] !== undefined) {
        if(first || this.props.apiData["ttv_channel_info"].message === "OK.") {
          this.tryRetrieve(first);
          if(first || this.state.auto_running) {
            setTimeout(function(){
              this.autoGetChannelRun();
            }.bind(this), timeout_ms);
          }
        } else {
          console.error("API returned error, stopped automation.");
          console.error(this.props.apiData["ttv_channel_info"].message);
          this.props.setAlert(this.props.apiData["ttv_channel_info"].message);
          document.title = "API error";
          this.setState({auto_running:false});
        }
      } else {
        this.tryRetrieve(first);
        if(first || this.state.auto_running) {
          setTimeout(function(){
            this.autoGetChannelRun();
          }.bind(this), timeout_ms);
        }
      }
    } else {
      if(first || this.state.auto_running) {
        console.warn("autoGetChannelRun has to wait 200ms.");
        setTimeout(function(){
          this.autoGetChannelRun();
        }.bind(this), 200);
      }
    }
  }

  tryRetrieve(first) {
    let page_cards = this.props.apiData["ttv_list"];
    let {auto_running, auto_max, auto_count, auto_retrieved} = this.state;
    if(first) {auto_running = true; auto_max = 2; auto_count = 0; auto_retrieved = 0;}
    let i = (first) ? 0 : auto_count;
    let item = page_cards.data[i];

    auto_count++;
    this.props.fetchDataIfReady(config.api_token, "ttv_channel_info", "GET", config.api_url+"/ttv-channel-info?t="+this.props.session_token+"&channel_id="+item.ext_id, undefined, null, true);
    auto_retrieved++; // todo: hoeft mss niet, was eerst op basis van is_zombie etc

    if(auto_retrieved >= auto_max || auto_count >= page_cards.data.length) {
      document.title = "done";
      auto_running = false;
    }

    this.setState({auto_running, auto_count, auto_retrieved});
  }

}


function mapStateToProps(state) {
  let session_token = null, ttv_list_is_fetching = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData["account_update"] !== undefined && state.apiData["account_update"].isFetching !== undefined) {
    ttv_list_is_fetching = state.apiData["account_update"].isFetching;
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
    ttv_list_is_fetching: ttv_list_is_fetching,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
    setAlert,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AutoGetChannel)



// WEBPACK FOOTER //
// ./src/containers/AutoGetChannel.js